import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import '../../../../assets/DigitalMarketing/Css/Style.css'
import 'react-datepicker/dist/react-datepicker.css';

function MonthLetterDatePicker(props) {
  
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  return (

    <DatePicker
      selected={props.selectedDate}
      onChange={props.onChange}
      dateFormat="dd MMM, yyyy"
      placeholderText="_ _ "
      id="date-picker"
      style={{ width: (props.data == 'lmp' && '115%') ||(props.data == 'lastPeriod' && '115%') ||(props.data == 'ovulationDate' && '115%') }}
      showYearDropdown
      // showTimeSelect
      //           showTimeSelectOnly
      scrollableYearDropdown
      yearDropdownItemNumber={15}
      withPortal
      customInputRef="datepicker"
      popperModifiers={{
        preventOverflow: {
          enabled: true,
          escapeWithReference: false,
          boundariesElement: 'viewport',
        },
      }}
      disabled={props?.disab||props?.view}
      minDate={(props.data !== "lastPeriod" && new Date())&&(props.data !== "lmp" && new Date())}
      maxDate={props.currentDate}
      className={`${(props.data == 'lmp' && "_lmp")||(props.data == 'lastPeriod' && "_lmp")||(props.data == 'ovulationDate' && "_lmp")}`}
/>
  );
}

export default React.memo(MonthLetterDatePicker);
